import { AddAccountApiParameterExt, addAccountExt as addAccountApiExt } from "@GeriMed/Services/AccountServiceExt";
import { AccountModelExt } from "@GeriMed/Type/ApiModelsExt";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";

export interface AddAccountParameter {
    Properties: any;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddAccountParameter,
    AddAccountApiParameterExt,
    ServiceResult<AccountModelExt>
>;

export const PopulateApiParameterExt: HandlerType = props => {
    props.apiParameter = {
        account: {
             ...props.parameter,
           Properties: props.parameter.Properties,
        } as unknown as AccountModelExt,
    };
};

export const AddAccountExt: HandlerType = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await addAccountApiExt(props.apiParameter);
    watchForOtherTabSessionChange();
};

export const chain = [
    PopulateApiParameterExt,
    AddAccountExt,
];

const addAccountExt = createHandlerChainRunner(chain, "AddAccountExt");
export default addAccountExt;
